// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage/LandingPage";
import Dashboard from "./pages/Dashboard/Dashboard";
import Projects from "./pages/Projects/Projects";
import Settings from "./pages/Settings/Settings";
import Feed from "./pages/Feed/Feed";
import Forum from "./pages/Forum/Forum";
import Messages from "./pages/Messages/Messages";
import Jobs from "./pages/Jobs/Jobs";
import Profile from "./pages/Profile/Profile";
import Admin from "./pages/Admin/Admin";
import DrawingApp from "./DrawingApp";
import Templates from "./pages/Templates/Templates";
import Documents from "./pages/Documents/Documents";
import Groups from "./pages/Groups/Groups";
import Questions from "./pages/Questions/Questions";
import Regulations from "./pages/Regulations/Regulations";
import Warnings from "./pages/Warnings/Warnings";
import Reviews from "./pages/Reviews/Reviews";
import Polls from "./pages/Polls/Polls";
import News from "./pages/News/News";
import Privacy from "./pages/Privacy/Privacy";
import NotifToast from "./components/common/NotifToast";

const App = () => {
  return (
    <Router>
      <NotifToast />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/dashboard" element={<Feed />} />
        <Route path="/explore" element={<Feed mode="explore" />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/feed" element={<Dashboard />} />
        <Route path="/forum" element={<Forum />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/questions" element={<Questions />} />
        <Route path="/regulations" element={<Regulations />} />
        <Route path="/warnings" element={<Warnings />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/polls" element={<Polls />} />
        <Route path="/news" element={<News />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/profile/:userId" element={<Profile />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/app/:projectId?" element={<DrawingApp />} />
        <Route path="/share/:token" element={<DrawingApp />} />
      </Routes>
    </Router>
  );
};

export default App;
